/** Internal Finnhouse player profile URLs always use the roster `name` field. */
export const getPlayerProfilePath = (name: string): string =>
  `/fpl/players/${encodeURIComponent(name.trim())}`;
